export default __webpack_public_path__ + "static/media/AnkitDhawanResume.647057b7.pdf";